var map = {
	"./home-entertainment.de-CH.json": 1362,
	"./home-entertainment.de-DE.json": 1363,
	"./home-entertainment.en-CA.json": 1364,
	"./home-entertainment.en-GB.json": 1365,
	"./home-entertainment.en-IN.json": 1366,
	"./home-entertainment.en-ME.json": 1367,
	"./home-entertainment.en-US.json": 1368,
	"./home-entertainment.es-EM.json": 1369,
	"./home-entertainment.es-ES.json": 1370,
	"./home-entertainment.fr-BE.json": 1371,
	"./home-entertainment.fr-CA.json": 1372,
	"./home-entertainment.fr-CH.json": 1373,
	"./home-entertainment.nl-BE.json": 1374,
	"./home-entertainment.nl-NL.json": 1375,
	"./home-entertainment.pl-PL.json": 1376,
	"./home-entertainment.pt-BR.json": 1377
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1361;